import type { InboundEmailStatus } from "@/services/inbound-email.service";

export const STATUS_LABEL: Record<InboundEmailStatus, string> = {
	received: "Queued",
	processing: "Processing",
	ready: "Ready",
	approving: "Approving",
	approved: "Approved",
	rejected: "Rejected",
	failed: "Failed",
	ignored: "Ignored",
};

export const STATUS_VARIANT: Record<InboundEmailStatus, "medium" | "review" | "urgent" | "low" | "high" | "done"> = {
	received: "low",
	processing: "low",
	ready: "medium",
	approving: "medium",
	approved: "done",
	rejected: "low",
	failed: "urgent",
	ignored: "low",
};

export const IGNORE_REASON_LABEL: Record<string, string> = {
	not_addressed: "Not addressed to the TaskHub address",
	disabled: "Email-to-Task was disabled",
	sender_not_allowed: "Sender not in the allowed domains or emails",
	sender_not_taskhub_user: "Sender is not an active TaskHub user",
	dkim_not_verified: "Sender could not be verified (DKIM)",
};

export const INBOX_TABS: { key: string; label: string; statuses: InboundEmailStatus[] }[] = [
	{ key: "ready", label: "Ready", statuses: ["ready", "approving"] },
	{ key: "queued", label: "Processing", statuses: ["received", "processing"] },
	{ key: "failed", label: "Failed", statuses: ["failed"] },
	{ key: "approved", label: "Approved", statuses: ["approved"] },
	{ key: "rejected", label: "Rejected", statuses: ["rejected"] },
	{ key: "ignored", label: "Ignored", statuses: ["ignored"] },
];

export function formatEmailDate(iso: string | null): string {
	if (!iso) return "";
	return new Date(iso).toLocaleString("en-US", {
		month: "short",
		day: "numeric",
		hour: "numeric",
		minute: "2-digit",
	});
}

export function countIncluded(groups: { include: boolean; subtasks: { include: boolean }[] }[]): number {
	return groups
		.filter((g) => g.include)
		.reduce((n, g) => n + 1 + g.subtasks.filter((s) => s.include).length, 0);
}
